import skrollr from 'skrollr';

const init = () => {
	const skroll = skrollr.init();

	if (skroll.isMobile()) {
		skroll.destroy();
	}
}

export default {
	init,
};
